import {ElementHelpers} from '../helpers/element-helpers';
import {Ajax} from '../helpers/ajax';
import {EventEmitter} from '../components/event-emitter';
import {JobSave} from '../components/job-save';
import {Templates} from '../helpers/templates';
import {Analytics} from '../helpers/analytics';
import {Scroll} from '../helpers/scroll';
import {breakpoints} from '../helpers/constants';
import {getParameterByName} from '../helpers/get-parameter-by-name';

export class Jobboard {

	constructor(elem) {
		this.elem = elem;

		this.renderedCards = this.elem.querySelectorAll('.search-card--vacancy');
		this.rendered = this.renderedCards.length;

		this.searchList = this.elem.querySelector('[data-lazy-board]');

		this.templates = {
			vacancyCard: Templates.getTemplateFromPage('templateVacancyCard'),
			loadMore: Templates.getTemplateFromPage('templateLoadMore')
		};

		this.endpoint = this.searchList.dataset.endpoint;
		this.pageSize = parseInt(this.searchList.dataset.lazyBoard);

		this.resultString = {
			single: this.elem.dataset.resultSingular || '',
			multiple: this.elem.dataset.resultMultiple || ''
		};

		this.initialLoadMoreButton = this.elem.querySelector('[data-load-more-initial]');
		this.clearFilterButton = this.elem.querySelectorAll('[data-lazy-clear-filters]');

		this.counters = this.elem.querySelectorAll('[data-board-counter]');
		this.resultStringContainer = this.elem.querySelectorAll('[data-result-string]');

		this.noResults = this.elem.querySelector('[data-lazy-no-results]') || undefined;

		this.currentPage = getParameterByName('pagina') || 1;

		this.form = this.elem.querySelector('form');

		this.input = this.form ? this.form.querySelectorAll('input') : '';
		this.checkboxes = this.form ? this.form.querySelectorAll('input[type="checkbox"]') : '';
		this.select = this.form ? this.form.querySelectorAll('select') : '';
		this.textInputs = this.form.querySelectorAll('input[type="text"]');
		this.distance = this.form.querySelectorAll('.form-group--distance select');
		this.autoSuggest = this.form.querySelectorAll('.autosuggest');
		this.checkboxesContainers = this.form.querySelectorAll('.job-search-filters__modal-checkboxes');

		this.toggleModal = this.elem.querySelectorAll('.job-search-filters__title');

		this.activeFiltersBlock = this.elem.querySelector('[data-active-filters]');
		this.activeFiltersBlockContainer = this.elem.querySelector('[data-active-filters-container]');

		this.facets = this.form.querySelectorAll('[data-jobboard-facet]');

		this.stickyContainer = this.form.querySelector('[data-set-sticky]');

		this.activeFiltersButtons = this.elem.querySelectorAll('[data-active-filter-button]');

		this.setModalDimensions = this.setModalDimensions.bind(this);

		this.init();
	}

	get activeFilterTemplate() {
		return `
			<button class="blog-filter__button active-filters__button link__button active" data-filter-name="{{filterName}}" data-filter-value="{{filterValue}}">
				{{text}}
				<span class="icon">
					<svg>
						<use xlink:href="#close-16"></use>
					</svg>
			  </span>
			</button>
		`
	}

	init() {
		this.addEventHandlers();
	}

	/**
	 * All necessary event Handlers
	 */
	addEventHandlers() {

		ElementHelpers.addEventListeners(this.checkboxes, 'change', (e) => {
			this.getData();
			Scroll.scrollPageTo(this.form, 500, (this.form.offsetHeight - this.stickyContainer.offsetHeight) * -1);
			const target = e.currentTarget;
			const analyticsData = {
				category: target.getAttribute(Analytics.analyticsTags.component),
				action: target.getAttribute(Analytics.analyticsTags.action),
				label: target.checked ? `selected - ${target.value}` : `deselect - ${target.value}`
			};
			Analytics.measure(analyticsData);
		});


		ElementHelpers.addEventListeners(this.distance, 'change', (e) => {

			this.currentPage = 1;

			const currentInput = e.target;
			this.setSameValueToDuplicateInputs(this.distance, currentInput);

			this.getData();
		});

		ElementHelpers.addEventListeners(this.textInputs, 'change', (e) => {

			this.currentPage = 1;

			const currentInput = e.target;
			this.setSameValueToDuplicateInputs(this.textInputs, currentInput);
			Scroll.scrollPageTo(this.form, 500, 0);

			// Setting a short timeout, else the autosuggest will be loading twice (one time because of the change of textinput, and again when selecting item in autosuggest)
			if (e.target.getAttribute('data-autosuggest') !== null) {
				clearTimeout(this.timeOut);
				this.timeOut = setTimeout(() => {
					this.getData(true, true, true);
				}, 200)
			} else {
				this.getData(true, true, true);
			}
		});

		if (this.autoSuggest.length > 0) {
			ElementHelpers.addEventListeners(this.autoSuggest, 'keyup', (e) => {
				this.toggleActiveDistance(e.target.value !== '');
			})
		}

		this.form.addEventListener('submit', (event) => {
			event.preventDefault();
			event.stopPropagation();
			this.getData(true, true, true);
			Scroll.scrollPageTo(this.form, 500, this.form.offsetHeight - this.stickyContainer.offsetHeight * -1);
		});


		if (this.initialLoadMoreButton) {
			this.initialLoadMoreButton.addEventListener('click', (e) => {
				e.preventDefault();
				this.currentPage++;
				this.getData(false, true, false);
				const parent = e.currentTarget.parentElement;
				ElementHelpers.removeElement(parent);
			})
		}

		ElementHelpers.addEventListeners(this.clearFilterButton, 'click', (e) => {
			e.preventDefault();
			this.clearAllFilters();
			Scroll.scrollPageTo(this.form, 500, 0);
		});

		ElementHelpers.addEventListeners(this.toggleModal, 'click', (e) => {
			if (!breakpoints.isMedium()) {
				const target = e.currentTarget;
				Scroll.scrollPageTo(target, 500, 0);

				this.navigationHtmlElement = target;
				window.requestAnimationFrame(this.setModalDimensions);
			}
		});

		ElementHelpers.addEventListeners(this.activeFiltersButtons, 'click', (e) => {
			this.clearFilter(e);
		});

		this.renderedCards.forEach((card) => {
			this.handleCardClick(card);
		})
	}

	/**
	 * Determines and sets the dimensions of the modal. This cannot be done with CSS only due to https://stackoverflow.com/a/33899301 and the absolute position of the modal
	 */
	setModalDimensions() {
		const stickyContainer = this.stickyContainer;
		const modalOffset = this.navigationHtmlElement.offsetLeft;
		const activeAccordion = document.querySelector('.job-search-filters__accordion._is-active');

		if(activeAccordion){
			const checkboxContainer = activeAccordion.querySelector('.job-search-filters__modal-checkboxes');
			const contentContainer = activeAccordion.querySelector('.job-search-filters__modal-content');
			const blockWrapper = activeAccordion.querySelector('.block__wrapper');

			//set contentContainer width to initial value
			contentContainer.style.width = 400 + 'px';

			// calculate and set modalHeight, 240px is for the apply filter button with padding, and margin to the bottom of the page
			const modalHeight = window.innerHeight - stickyContainer.offsetHeight - 240;
			checkboxContainer.style.maxHeight = modalHeight + 'px';

			//use the scrollWidth to determine the required contentContainer width, add 60 for 30 padding on both sides
			const modalWidth =  (checkboxContainer.scrollWidth + 60) + 'px';
			contentContainer.style.width = modalWidth;
			blockWrapper.style.width = modalWidth;

			//offset the modal so it shows below the clicked navigation element
			blockWrapper.style.left = modalOffset + 'px';
		}
	}

	/**
	 * Toggle to enable or disable distance dropdown
	 * @param isEnabled
	 */
	toggleActiveDistance(isEnabled) {
		for (let i = 0; i < this.distance.length; i++) {
			const distanceInput = this.distance[i];
			const distanceContainer = ElementHelpers.getParentByClass(distanceInput, 'form-group');

			if (distanceContainer) {
				isEnabled ? distanceContainer.classList.remove('disabled') : distanceContainer.classList.add('disabled');
			}
			distanceInput.disabled = !isEnabled;
		}
	}

	/**
	 * We have duplicated some inputs to show them on Mobile or Desktop, and with this function we give the inputs with the same [name] attribute, the same value.
	 * @param inputs
	 * @param currentInput
	 */
	setSameValueToDuplicateInputs(inputs, currentInput) {
		for (let i = 0; i < inputs.length; i++) {
			const input = inputs[i];
			if ((input !== currentInput) && (input.name === currentInput.name)) {
				input.value = currentInput.value;
			}
		}
	}

	/**
	 * Get the data from endpoint
	 * @param clearboard
	 * @param measure
	 */
	getData(clearboard, measure = true, initialLoader = false) {
		this.generateLoader(initialLoader);
		const separator = this.endpoint.indexOf('?') === -1 ? '?' : '&';
		const params = this.getParams();
		if (clearboard) this.rendered = 0;
		Ajax.GET(this.generateUrl(separator, params)).then((results) => {
			this.setActiveFilters(params);
			this.updateBoard(results, clearboard);
			this.updateWindowLocation(params);
			this.setCounterPerFilter(results.filters);
			this.toggleMobileClearFilterButton();
			this.setFacetCounter();
			this.setTotalSelectedCheckboxesMobile();
			this.toggleClearFilterButtons('on');
			if (measure) this.handleAnalytics();
			if (this.currentPage === 1) {
				const data = {
					category: this.form.getAttribute(Analytics.analyticsTags.component),
					action: this.form.getAttribute(Analytics.analyticsTags.action),
					label: parseInt(results.totalResults) || '0'
				};
				Analytics.measure(data)
			}
			this.hideLoader();
		}, () => {
			console.error('Error loading endpoint');
			return false;
		});
	}

	/**
	 * Updates the jobboard with the results
	 * @param data
	 * @param clearBoard
	 */
	updateBoard(data, clearBoard = true) {
		const total = parseInt(data.totalResults);
		const vacancies = data.vacancies || '';

		if (clearBoard) this.searchList.innerHTML = '';

		this.updateCounters(total);
		this.updateResultString(total);

		this.toggleNoResults(total);

		const dataAnalyticsArray = this.getDataAnalyticsArray(data);

		let delay = 0;

		for (let i = 0; i < vacancies.length; i++) {
			let card = this.createCard();
			let dataArray = {templateData: []};
			if (dataAnalyticsArray && !vacancies[i].analyticsData) vacancies[i].analyticsData = this.getDataAnalyticsObject(dataAnalyticsArray, vacancies[i].vacancyNumber);
			dataArray.templateData = this.parseData(vacancies[i]);
			Templates.renderTemplate(this.templates.vacancyCard, card, dataArray);
			Analytics.initTrackLinkClicks(card);
			card = card.children[0];
			this.searchList.appendChild(card);
			delay += 150;
			card.style.animationDelay = delay + 'ms';
			this.rendered++;
			new JobSave(card);
			this.handleCardClick(card);
		}

		this.registerLazyload(data.currentPage, data.pages);

	}

	handleCardClick(card) {
		card.addEventListener('click', (e) => {
			if(breakpoints.isMedium()){
				const href = e.currentTarget.href;
				e.preventDefault();
				window.open(href, '_self')
			}
		})
	}

	/**
	 * Parses data to a correct JSON object for analytics
	 * @param data
	 * @returns {{analyticsData}|*}
	 */
	parseData(data) {
		if (data.analyticsData) {
			data.analyticsData = JSON.stringify(data.analyticsData);
			data.analyticsData = data.analyticsData.replace(/"/g, '&quot;');
		}
		return data;
	}

	/**
	 * Get analyticsDataArray
	 * @param data
	 * @returns {string}
	 */
	getDataAnalyticsArray(data) {
		return data.relay42 && data.relay42.jobListing ? data.relay42.jobListing : '';
	}

	/**
	 * Place dataAnalytics to correct vacancyObject based on vacancyNumber
	 * @param dataAnalyticsArray
	 * @param vacancyNumber
	 * @returns {*}
	 */
	getDataAnalyticsObject(dataAnalyticsArray, vacancyNumber) {
		return dataAnalyticsArray.find(obj => {
			return obj.aanvraagNummer === vacancyNumber;
		});
	}

	/**
	 * Updates all the counters to the total amount of vacancies (in buttons and on top of jobboard)
	 * @param amount
	 */
	updateCounters(amount) {
		for (let i = 0; i < this.counters.length; i++) {
			const counter = this.counters[i];
			counter.innerHTML = amount;
		}
	}

	/**
	 * Updated the resultString for singular or multiple results
	 * @param amount
	 */
	updateResultString(amount) {
		const resultString = amount === 1 ? this.resultString.single : this.resultString.multiple;
		for (let i = 0; i < this.resultStringContainer.length; i++) {
			const container = this.resultStringContainer[i];
			container.innerHTML = resultString;
		}
	}

	/**
	 * Toggles the noResults container
	 * @param total
	 */
	toggleNoResults(total) {
		if (this.noResults) {
			if (total <= 0) {
				this.noResults.dataset.lazyNoResults = 'visible';
				this.noResults.style.display = 'block';
			} else {
				this.noResults.dataset.lazyNoResults = 'hidden';
				this.noResults.style.display = 'none';
			}
		}
	}

	/**
	 * Sets the counter for the amount of selected checkboxes per facet
	 */
	setFacetCounter() {
		for (let i = 0; i < this.facets.length; i++) {
			const facet = this.facets[i];
			const checkedInputs = facet.querySelectorAll('input:checked').length;
			const facetCounter = facet.querySelector('[data-jobboard-facet-counter]');
			if (checkedInputs > 0) {
				facet.classList.add('_has-active-filters');
				facetCounter.innerHTML = checkedInputs;
			} else {
				facet.classList.remove('_has-active-filters');
				facetCounter.innerHTML = '';
			}
		}
	}

	/**
	 * Sets all active filters based on currents query params
	 * @param params
	 */
	setActiveFilters(params) {
		let paramsArray = params.split('&');
		// Filter empty strings
		paramsArray = paramsArray.filter((el) => {
			return el;
		});

		// get index of 'afstand' parameter
		const distanceIndex = paramsArray.findIndex((test) => {
			return test.includes('afstand');
		});

		const activeFiltersArray = this.getActiveFilterInArrays(paramsArray);

		this.updateCurrentFilters(activeFiltersArray, distanceIndex);
	}

	/**
	 * Creates an array with arrays of every parameter with [0] the key and [1] the value
	 * @param paramsArray
	 * @returns {[]}
	 */
	getActiveFilterInArrays(paramsArray) {
		let activeFilters = [];
		for (let i = 0; i < paramsArray.length; i++) {
			const parameter = paramsArray[i];
			let parameterValues;
			if (parameter) parameterValues = parameter.split('=');
			activeFilters.push(parameterValues);
		}
		return activeFilters;
	}

	/**
	 *
	 * @param activeFilterArray
	 * @param distanceIndex
	 */
	updateCurrentFilters(activeFilterArray, distanceIndex) {
		this.activeFiltersBlockContainer.innerHTML = '';
		//const clearFiltersButton = this.currentFilterContainer.querySelector('[data-lazy-clear-filters]');

		for (let i = 0; i < activeFilterArray.length; i++) {
			const activeFilter = activeFilterArray[i];
			let distanceArray = false;
			if (activeFilter[0] === 'locatie') {
				distanceArray = activeFilterArray[distanceIndex];
			}
			if (activeFilter[0] !== 'afstand' && activeFilter[0] !== 'pagina') {
				this.drawFilterButton(activeFilter, distanceArray);
			}
		}

		if (this.hasActiveFilters()) {
			this.activeFiltersBlock.classList.add('_has-filters');
		} else {
			this.activeFiltersBlock.classList.remove('_has-filters');
		}
	}

	/**
	 * Draws the button for the active filter
	 * @param activeFilter
	 * @param distanceArray
	 */
	drawFilterButton(activeFilter, distanceArray) {

		let buttonText = decodeURIComponent(activeFilter[1]);
		if (distanceArray) buttonText += ` < ${distanceArray[1]}km`;

		let button = document.createElement('button');

		const template = this.activeFilterTemplate;
		Templates.renderTemplate(template, button, {
			text: buttonText.replace(/\\"/g, ''),
			filterName: activeFilter[0],
			filterValue: decodeURIComponent(activeFilter[1])
		});
		button = button.children[0];

		this.activeFiltersBlockContainer.appendChild(button);
		button.addEventListener('click', (e) => {
			this.clearFilter(e);
			const analyticsData = {
				category: `jobboard_filter_${activeFilter[0]}`,
				action: 'click - interact',
				label: `delete - ${decodeURIComponent(activeFilter[1])}`
			};
			Analytics.measure(analyticsData);
		})
	}

	/**
	 * Clears current filter
	 * @param event
	 */
	clearFilter(event) {
		const button = event.currentTarget;
		const filterName = button.dataset.filterName;
		const filterValue = button.dataset.filterValue;

		const inputField = this.form.querySelectorAll(`input[name='${filterName}']`);

		for (let i = 0; i < inputField.length; i++) {
			if (inputField[i].type !== 'checkbox') {
				inputField[i].value = '';
				if (inputField[i].classList.contains('autosuggest')) this.toggleActiveDistance(false);
			} else if (inputField[i].value === filterValue) {
				inputField[i].checked = false;
			}
		}

		button.classList.add('link__button--disabled');
		this.currentPage = 1;
		this.getData(true, true, true, false);
	}

	/**
	 * Clears all filters
	 */
	clearAllFilters() {
		this.toggleClearFilterButtons('off');
		this.currentPage = 1;
		const inputs = this.input;
		for (let i = 0; i < inputs.length; i++) {
			const input = inputs[i];
			if (input.type === 'checkbox') {
				input.checked = false;
			} else {
				input.value = '';
			}
		}
		this.toggleActiveDistance(false);
		this.getData(true, true, true);
	}

	/**
	 * Sets the opacity to 0.5 after clicking the button, and back to 1 after load of data.
	 * @param status
	 */
	toggleClearFilterButtons(status){
		for (let i = 0; i < this.clearFilterButton.length; i++) {
			this.clearFilterButton[i].style.opacity = status === 'off' ? 0.5 : 1;
		}
	}

	/**
	 * Sets the amount of vacancies next to every checkbox (e.g. Engeneering (20));
	 * @param filters
	 */
	setCounterPerFilter(filters) {
		const filtersValues = Object.values(filters);
		for (const filterValue of filtersValues) {
			for (let i = 0; i < filterValue.length; i++) {
				const singleFilterObject = filterValue[i];
				const checkbox = this.form.querySelector(`[data-jobboard-checkbox="${singleFilterObject.id}"]`);
				const checkboxCounter = checkbox ? checkbox.querySelector('[data-checkbox-label-counter]') : '';
				if (checkboxCounter) checkboxCounter.innerHTML = singleFilterObject.count;
			}
		}
	}

	/**
	 * Sets the total amount of selected checkboxes in the 'filteren' button on mobile
	 */
	setTotalSelectedCheckboxesMobile() {
		const filterenButton = this.form.querySelector('[data-filter-button-mobile]');
		const filterButtonCounter = filterenButton.querySelector('[data-jobboard-mobile-counter]');
		let counter = 0;

		for (let i = 0; i < this.checkboxes.length; i++) {
			const checkbox = this.checkboxes[i];
			if (checkbox.checked) counter++;
		}

		if (counter !== 0) {
			filterenButton.classList.add('_has-active-filters');
			filterButtonCounter.innerHTML = counter;
		} else {
			filterenButton.classList.remove('_has-active-filters');
			filterButtonCounter.innerHTML = '0';
		}
	}

	/**
	 * Checks if there are active filters in the activeFiltersBlockContainer block.
	 * @returns {string}
	 */
	hasActiveFilters() {
		return this.activeFiltersBlockContainer.innerHTML;
	}

	/**
	 * Toggles the 'clear all filters' button on the layover on mobile
	 */
	toggleMobileClearFilterButton() {
		const clearFilterButton = this.form.querySelector('[data-clear-filters-layover]');
		if(this.hasActiveFilters()){
			clearFilterButton.classList.add('_has-filters');
		}else{
			clearFilterButton.classList.remove('_has-filters');
		}
	}

	/**
	 * Generates the loader
	 * @param initial
	 */
	generateLoader(initial) {
		if (!this.searchList.querySelector('.loader-container')) {
			this.loader = document.createElement('div');
			this.loader.classList.add('loader-container');
			if (initial) {
				this.loader.classList.add('loader-container--top');
			}
			this.loader.innerHTML = '<div class="loader"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
			this.searchList.appendChild(this.loader);
		}
		if (this.noResults && this.noResults.dataset.lazyNoResults === 'visible') this.noResults.style.opacity = '0.3';
	}

	/**
	 * Removed the loader
	 */
	hideLoader() {
		if (this.noResults && this.noResults.dataset.lazyNoResults === 'visible') this.noResults.style.opacity = '1';
		ElementHelpers.removeElement(this.loader);
	}

	/**
	 * Get parameters
	 * @returns {string}
	 */
	getParams() {
		let params = '';
		params += this.getQueryParams();
		params += this.setPagination();

		return params;
	}

	/**
	 * Set pagination
	 * @returns {string}
	 */
	setPagination() {
		return this.currentPage > 1 ? '&pagina=' + this.currentPage : '';
	}

	/**
	 * sets the pagesize
	 * @returns {string}
	 */
	setPageSize() {
		return this.pageSize !== 20 ? `&pageSize=${this.pageSize}` : '';
	}

	/**
	 * Update window URL to current query params
	 * @param string
	 */
	updateWindowLocation(string) {
		string = string.charAt(0) === '&' ? string.substring(1) : string;
		const newUrl = string ? window.location.href.split('?')[0] + '?' + string : window.location.href.split('?')[0];
		window.history.replaceState({}, document.title, newUrl);
	}

	/**
	 * Generate URL for Ajax call to fetch
	 * @param separator
	 * @param params
	 * @returns {*}
	 */
	generateUrl(separator, params) {
		return this.endpoint + separator + params + this.setPageSize();
	}

	/**
	 * Adds the Load more results button of there are any
	 * @param currentPage
	 * @param totalPages
	 */
	registerLazyload(currentPage, totalPages) {
		if (currentPage < totalPages) {
			const container = document.createElement('div');
			container.classList.add('load-more-btn__wrapper');
			Templates.renderTemplate(
				this.templates.loadMore,
				container,
				{options: ''}
			);
			this.searchList.appendChild(container);
			const button = this.searchList.querySelector('.button__load-more');
			button.addEventListener('click', (event) => {
				event.preventDefault();
				this.currentPage++;
				Analytics.handleLinkClick(event.target);
				this.getData(false, true);
				ElementHelpers.removeElement(event.currentTarget.parentNode);
			});
		}
	}

	/**
	 * Creates a card
	 * @returns {HTMLDivElement}
	 */
	createCard() {
		return document.createElement('div');
	}

	static getSelector() {
		return '[data-lazyload-jobboard]';
	}

	/**
	 * Set correct string as Parameter.
	 * @param divider
	 * @param input
	 * @param string
	 * @returns {string}
	 */
	setString(divider, input, string) {
		const paramString = divider + input.name + '=' + encodeURIComponent(input.value);
		// Make sure no duplicate filter names and values are inserted
		if (string.indexOf(paramString) === -1) return paramString;
		return '';
	}


	//@TODO: Thise code is duplicate code from ../lazyload-board.js, so place this in a separate file and import it in both files.
	/**
	 * Emit an event to the Analytics class so data is collected
	 */
	handleAnalytics() {
		EventEmitter.emit('LazyloadBoard:getData');
	}

	getQueryParams() {
		let inputs = this.input;
		let selects = this.select;
		let divider = '&';
		let string = '';

		if (inputs) {
			string = this.getInputString(inputs, string, divider);
		}

		if (selects) {
			string = this.getSelectsString(selects, string, divider);
		}

		return string;
	}

	getInputString(inputs, string, divider) {
		for (let i = 0; i < inputs.length; i++) {
			if (inputs[i].type === 'checkbox' && inputs[i].checked) {
				string += this.setString(divider, inputs[i], string);
			} else if (inputs[i].type === 'search' && inputs[i].value) {
				this.setString(divider, inputs[i], string);
				string += this.setString(divider, inputs[i], string);
			} else if (inputs[i].type === 'text' && inputs[i].value) {
				this.setString(divider, inputs[i], string);
				string += this.setString(divider, inputs[i], string);
			}
			inputs[i].blur();
		}

		return string;
	}

	getSelectsString(selects, string, divider) {
		for (let i = 0; i < selects.length; i++) {
			if (!selects[i].disabled) {
				string += this.setString(divider, selects[i], string);
			}
		}
		return string;
	}
}
